export default "__VITE_ASSET__CgI2Gqez__"